<ig-accordion 
  #accordion 
  [mode]="mode" 
  [title]="title" 
  class="event-date-filter" 
  [menuClass]="menuClass"
  (onIconClicked)="clear()"
  role="region"
  [attr.aria-label]="'Date filter: ' + (title || 'All dates')">
  
  <ng-container expand>
    <ng-container *ngTemplateOutlet="eventDateFilter">
    </ng-container>
  </ng-container>

  <ng-container dropdown>
    <div role="menu" [attr.aria-label]="'Date filter options'" (keydown.arrowDown)="$event.preventDefault(); focusNext($event.target)" (keydown.arrowUp)="$event.preventDefault(); focusPrevious($event.target)">
      <ng-container *ngTemplateOutlet="eventDateFilter">
      </ng-container>
    </div>
  </ng-container>

  <ng-template #eventDateFilter>
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'ALL'"
      (click)="changeDate('all')"
      (keydown.enter)="changeDate('all')"
      (keydown.space)="changeDate('all'); $event.preventDefault()">
      ALL
    </button>
    
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'TODAY'"
      (click)="changeDate('today')" 
      [class.date-selected]="title==='TODAY'"
      (keydown.enter)="changeDate('today')"
      (keydown.space)="changeDate('today'); $event.preventDefault()">
      TODAY
    </button>
      
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'TOMORROW'"
      (click)="changeDate('tomorrow')" 
      [class.date-selected]="title==='TOMORROW'"
      (keydown.enter)="changeDate('tomorrow')"
      (keydown.space)="changeDate('tomorrow'); $event.preventDefault()">
      TOMORROW
    </button>
      
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'THIS WEEK'"
      (click)="changeDate('this-week')" 
      [class.date-selected]="title==='THIS WEEK'"
      (keydown.enter)="changeDate('this-week')"
      (keydown.space)="changeDate('this-week'); $event.preventDefault()">
      THIS WEEK
    </button>
      
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'THIS WEEKEND'"
      (click)="changeDate('this-weekend')" 
      [class.date-selected]="title==='THIS WEEKEND'"
      (keydown.enter)="changeDate('this-weekend')"
      (keydown.space)="changeDate('this-weekend'); $event.preventDefault()">
      THIS WEEKEND
    </button>
      
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title === 'THIS MONTH'"
      (click)="changeDate('this-month')" 
      [class.date-selected]="title==='THIS MONTH'"
      (keydown.enter)="changeDate('this-month')"
      (keydown.space)="changeDate('this-month'); $event.preventDefault()">
      THIS MONTH
    </button>
      
    <button 
      mat-menu-item 
      role="menuitemradio" 
      [attr.aria-checked]="title.includes('FROM') || title.includes('SPECIFIC DATE')"
      (click)="$event.stopPropagation(); isShowSpecificDates = true"
      (keydown.enter)="$event.stopPropagation(); isShowSpecificDates = true"
      (keydown.space)="$event.stopPropagation(); isShowSpecificDates = true; $event.preventDefault()"
      [class.date-selected]="title.includes('FROM') || title.includes('SPECIFIC DATE')">
      DATE RANGE
    </button>

    <div *ngIf="isShowSpecificDates" 
         role="region" 
         [attr.aria-label]="'Date range picker'"
         class="date-range-picker-container">
      <ig-date-range-picker 
        [class.date-selected]="title.includes('SPECIFIC DATE')" 
        #dateRangePicker 
        (onRangeChanged)="dateRangeChanged($event)">
      </ig-date-range-picker>
    </div>
  </ng-template>
</ig-accordion>
